import { IntakeFormStatus, ClientIntakeForm } from '@models/client-intake';

export class CreateIntakeForm {
	static readonly type = '[matter-client-intake] create intake form';
	constructor(public payload: { clientIntakeForm: ClientIntakeForm }) {}
}

export class GetIntakeFormById {
	static readonly type = '[matter-client-intake] get intake form by id';
	constructor(public payload: { intakeFormId: string }) {}
}

export class UpdateStatus {
	static readonly type = '[matter-client-intake] update status on intake form';
	constructor(
		public payload: { intakeFormId: string; status: IntakeFormStatus },
	) {}
}

export class DeactivateIntakeForm {
	static readonly type = '[matter-client-intake] deactivate intake form';
	constructor(public payload: { intakeFormId: string }) {}
}
